// Pure invoice math shared by the invoice list and pay dialog.

const EPS = 0.005;

/** Outstanding balance for an invoice = amount - amount_paid, floored at 0. */
export function outstandingBalance(inv) {
  const amount = Number(inv?.amount) || 0;
  const paid = Number(inv?.amount_paid) || 0;
  return Math.max(0, Math.round((amount - paid) * 100) / 100);
}

/** True when the invoice is settled (server status paid, or zero balance). */
export function isFullyPaid(inv) {
  if (inv?.status === "paid") return true;
  return outstandingBalance(inv) <= EPS;
}

/** Validate a payment amount against the current balance. Returns an error
 *  string, or "" when the amount is acceptable. */
export function validatePaymentAmount(amount, balance) {
  const amt = Number(amount);
  if (!Number.isFinite(amt) || amt <= 0) return "Enter an amount greater than 0.";
  if (amt > balance + EPS) return `Amount exceeds the outstanding balance (${balance.toFixed(2)}).`;
  return "";
}
